import http from '@/http'
import lms from '@/http/lms'
export default {
  namespaced: true,
  state: {
    courses: [],
    lessons: [],
    course: {},
    courseProgress: [],
    ready: false,
    searchedContent: '',
    searchedContentItems: [],
    volume: 50,
    isMuted: false,
    playbackRate: 1,
    playQuality: 0,
    isKeepWatching: false,
    myProgressKeepWatching: [],
    selectedTheme: {},
    showRatingModal: false
  },
  mutations: {
    setCourses(state, itens) {
      state.courses = itens
    },
    setReady(state) {
      state.ready = true
    },
    setCourse(state, course) {
      state.course = course
    },
    setCourseProgress(state, courseProgress) {
      state.courseProgress = courseProgress
    },
    hydrateLesson(state, lesson) {
      state.lessons.push(lesson)
    },
    setSearchedContent(state, content) {
      state.searchedContent = content
    },
    setSearchedContentItems(state, searchedContentItems) {
      state.searchedContentItems = searchedContentItems
    },
    setVolume(state, _volume) {
      state.volume = _volume
    },
    setIsMuted(state, isMuted) {
      state.isMuted = isMuted
    },
    setPlaybackRate(state, playbackRate) {
      state.playbackRate = playbackRate
    },
    setPlayQuality(state, playQuality) {
      state.playQuality = playQuality
    },
    setIsKeepWatching(state, isKeepWatching) {
      state.isKeepWatching = isKeepWatching
    },
    setMyProgressKeepWatching(state, myProgressKeepWatching) {
      state.myProgressKeepWatching = myProgressKeepWatching
    },
    setSelectedTheme(state, themeSelected) {
      state.themeSelected = themeSelected
    },
    setShowRatingModal(state, showRatingModal) {
      state.showRatingModal = showRatingModal
    }
  },
  actions: {
    async getCourses({ commit }, { perPage = 10, page = 1 }) {
      try {
        const response = await lms.get('/courses', { params: { perPage, page } })
        commit('setCourses', response.data.data)
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async getCourseByID({}, courseID) {
      try {
        const response = await lms.get(`/courses/${courseID}`)
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async getPublicCourseByID({}, courseID) {
      try {
        const response = await lms.get(`/public/courses/${courseID}`)
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async getCoursesProgress({ commit }) {
      try {
        const response = await lms.get('/courses/progress')
        commit('setCourseProgress', response.data.data)
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async coursesSearch({}, content) {
      try {
        const response = await lms.get(`/courses/search?search=${content}`)
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async getLessonByID({}, props) {
      try {
        const response = await lms.get(`/lessons/${props.lessonID}`)
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async getPublicLessonByID({}, props) {
      try {
        const response = await lms.get(`/public/lessons/${props.lessonID}`)
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async supportCreate({}, { question, courseTitle }) {
      try {
        const response = await http.post('/support/create', {
          body: question,
          subject: courseTitle
        })
        return response.data
      } catch (err) {
        console.error(err)
      }
    },
    async getUserRating({}, ratingReference) {
      try {
        const response = await lms.get(`/ratings/${ratingReference}`)
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    },
    async createRating({}, props) {
      try {
        const response = await lms.post('/ratings', {
          userID: props.userID,
          ratingReference: props.ratingReference,
          ratingType: props.ratingType,
          ratingKind: props.ratingKind,
          ratingValue: props.ratingValue
        })
        return response.data
      } catch (err) {
        console.error(err)
      }
    }
  },
  getters: {
    getCourses: state => state.courses,
    searchedContent: state => state.searchedContent,
    getCourse: state => state.course,
    getCourseProgress: state => state.courseProgress,
    searchedContentItems: state => state.searchedContentItems,
    getVolume: state => state.volume,
    getIsMuted: state => state.isMuted,
    getPlaybackRate: state => state.playbackRate,
    getPlayQuality: state => state.playQuality,
    getIsKeepWatching: state => state.isKeepWatching,
    getKeepWatching: state => state.myProgressKeepWatching,
    themeSelected: state => state.themeSelected,
    showRatingModal: state => state.showRatingModal
  }
}
